import { PresentationComponentProps } from "../../../index";

export const FlatForm = (props: PresentationComponentProps) => {
  const fields = props.schema.mapFields(
    field => {
      return field;
    },
    { data: props.data }
  );

  return props.fieldMapper(fields);
};
